import { FilterOptionType } from '../../filter/types/types';
import { ArticleSearchProps, FilterOptions } from '../../searchArticles/types';
import {
  defaultEmptyFilters,
  VariantsSearchQuery,
} from '@texas/api/endpoints/search/searchVariantsTypes';
import {
  defaultEmptyFilters as defaultEmptyPaFilters,
  PaSearchQuery,
} from '@texas/api/endpoints/search/searchPaTypes';
import { PaSearchProps } from '../../widgets/ProductApprovals/types';

export const pageSize = 12;
export const defaultPage = 1;
const defaultSearchParams: VariantsSearchQuery = {
  searchTerm: '',
  sortBy: '',
  sortDesc: false,
  page: defaultPage,
  ...defaultEmptyFilters,
  showAllVariants: undefined,
  includeArchived: undefined,
  showMyBrands: false,
};

export const defaultArticlesWidgetOptions = (
  customerId: number | undefined,
  conceptId: number | undefined,
) => {
  return pageOptions(customerId, conceptId);
};

function pageOptions(
  customerId: number | undefined,
  conceptId: number | undefined,
) {
  if (customerId) {
    return brandsOptions(customerId);
  } else if (conceptId) {
    return conceptOptions(conceptId);
  }

  throw Error('Customer or concept properties not declared');
}

const brandsOptions = (customerId: number) => {
  const defaultSearchPage: ArticleSearchProps = {
    filters: [FilterOptionType.Customers],
    searchParams: { ...defaultSearchParams, customerIds: [customerId] },
  };

  const filterOptions: FilterOptions = {
    [FilterOptionType.Customers]: {
      static: true,
      disabled: true,
    },
    [FilterOptionType.ShowMyBrands]: {
      static: true,
      disabled: true,
    },
  };

  return { defaultSearchPage, filterOptions };
};

const conceptOptions = (conceptId: number) => {
  const defaultSearchPage: ArticleSearchProps = {
    filters: [FilterOptionType.Concepts],
    searchParams: { ...defaultSearchParams, conceptIds: [conceptId] },
    view: 'table',
  };

  const filterOptions: FilterOptions = {
    [FilterOptionType.Customers]: {
      static: true,
      disabled: true,
    },
    [FilterOptionType.Concepts]: {
      static: true,
      disabled: true,
    },
    [FilterOptionType.ShowMyBrands]: {
      static: true,
      disabled: true,
    },
  };

  return { defaultSearchPage, filterOptions };
};

const defaultPaSearchParams: PaSearchQuery = {
  searchTerm: '',
  sortBy: '',
  sortDesc: false,
  page: 1,
  ...defaultEmptyPaFilters,
  includeArchived: undefined,
  showMyBrands: false,
};

export const defaultPaWidgetOptions = (customerId: number) => {
  const defaultSearchPage: PaSearchProps = {
    filters: [FilterOptionType.Customers],
    searchParams: { ...defaultPaSearchParams, customerIds: [customerId] },
  };

  const filterOptions: FilterOptions = {
    [FilterOptionType.Customers]: {
      static: true,
      disabled: true,
    },
    [FilterOptionType.ShowMyBrands]: {
      static: true,
      disabled: true,
    },
  };

  return { defaultSearchPage, filterOptions };
};
